import { useEffect, useState } from "react";
import { Quotes, Star } from "@phosphor-icons/react";
import api from "@/lib/api";
import SEO from "@/components/SEO";
import PageHero from "@/components/PageHero";
import StarRating from "@/components/StarRating";
import { Reveal } from "@/components/Reveal";

export default function Testimonials() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/testimonials").then((r) => setItems(r.data)); }, []);

  return (
    <>
      <SEO title="Customer Reviews & Testimonials" description="Read verified reviews from thousands of happy Ebikes&Gear riders across the UK and Europe. Rated 4.9/5." path="/testimonials" />
      <PageHero title="Loved by riders across Europe" subtitle="Don't just take our word for it — here's what thousands of our customers have to say." image="https://images.unsplash.com/photo-1710760743800-b27ae6d05d05?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600" crumbs={[{ label: "Testimonials" }]} />

      <section className="container-px py-12">
        <div className="grid gap-4 sm:grid-cols-3">
          {[["4.9", "Average rating"], ["20,000+", "Happy riders"], ["98%", "Would recommend"]].map(([n, l]) => (
            <div key={l} className="rounded-3xl border border-border bg-card p-6 text-center">
              <div className="text-4xl font-black text-primary">{n}</div>
              <div className="mt-1 text-sm text-muted-foreground">{l}</div>
            </div>
          ))}
        </div>

        <div className="mt-8 columns-1 gap-5 sm:columns-2 lg:columns-3 [&>*]:mb-5">
          {items.map((t, i) => (
            <Reveal key={i}>
              <div className="break-inside-avoid rounded-3xl border border-border bg-card p-6" data-testid={`testimonial-${i}`}>
                <Quotes size={32} weight="fill" className="text-primary/30" />
                <p className="mt-3 leading-relaxed">{t.text}</p>
                <div className="mt-4 flex items-center justify-between">
                  <div>
                    <p className="font-bold">{t.name}</p>
                    <p className="text-sm text-muted-foreground">{t.role} · {t.location}</p>
                  </div>
                  <StarRating value={t.rating} />
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </section>
    </>
  );
}
